export default __webpack_public_path__ + "static/media/videos.966ad084.svg";